import React, { memo } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Chat from './pages/Chat';
import Memory from './pages/Memory';
import FamilyCheckIn from './pages/FamilyCheckIn';
import Setup from './pages/Setup';
import Help from './pages/Help';
import MoodCheckIn from './components/MoodCheckIn';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/chat" element={<Chat data-id="element-7" />} data-id="element-6" />
          <Route path="/memory" element={<Memory data-id="element-9" />} data-id="element-8" />
          <Route path="/family" element={<FamilyCheckIn data-id="element-11" />} data-id="element-10" />
          <Route path="/setup" element={<Setup data-id="element-13" />} data-id="element-12" />
          <Route path="/help" element={<Help data-id="element-15" />} data-id="element-14" />
          <Route path="/mood" element={<MoodCheckIn data-id="element-17" />} data-id="element-16" />
        </Route>
      </Routes>
    </Router>;
}